/**
 * Circle Playdate scheduling constants (Phase 3.1B / 3.1A contract).
 */

/** Minimum lead time from now to scheduledStartAt for proposals. */
export const CIRCLE_PLAYDATE_MIN_LEAD_MS = 30 * 60 * 1000

/** Maximum scheduling horizon ahead of now. */
export const CIRCLE_PLAYDATE_MAX_HORIZON_MS = 60 * 24 * 60 * 60 * 1000

/** Proposal TTL absolute max from creation. */
export const CIRCLE_PLAYDATE_PROPOSAL_TTL_MS = 72 * 60 * 60 * 1000

/** Proposal must expire at least this long before start. */
export const CIRCLE_PLAYDATE_PROPOSAL_EXPIRE_BEFORE_START_MS = 60 * 60 * 1000

/** Inclusive duration bounds. */
export const CIRCLE_PLAYDATE_MIN_DURATION_MS = 30 * 60 * 1000
export const CIRCLE_PLAYDATE_MAX_DURATION_MS = 180 * 60 * 1000

/** Custom public location label max length. */
export const CIRCLE_PLAYDATE_CUSTOM_LOCATION_MAX_LEN = 80

/**
 * Optional note max length (includes short planning envelope for presentation mode).
 * User-visible note body remains short; envelope is stripped in the DTO.
 */
export const CIRCLE_PLAYDATE_NOTE_MAX_LEN = 320

export function computeProposeExpiresAt(createdAt: Date, scheduledStartAt: Date): Date {
  const fromTtl = new Date(createdAt.getTime() + CIRCLE_PLAYDATE_PROPOSAL_TTL_MS)
  const beforeStart = new Date(
    scheduledStartAt.getTime() - CIRCLE_PLAYDATE_PROPOSAL_EXPIRE_BEFORE_START_MS
  )
  return fromTtl.getTime() <= beforeStart.getTime() ? fromTtl : beforeStart
}
